import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserPageSF from '../../../templates/SuperUserPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAnalyzerSF from '../../../components/superUser/clientTxn/BankAnalyzerSF'
import ClientTxnCashTransactionListSF from '../../../components/superUser/clientTxn/ClientTxnCashTransactionListSF'
// import './ClientTxnCashTransactionListPage.css'

const ClientTxnCashTransactionListPageUI = ({ context, account, errorList, transactionList,
  onRefreshClick, yearMonth, category,
  hasMore, onMoreTransactions, gettingMore,
}) =>
  <SuperUserPageSF context={context} className='pg_su_ct_cat_txn'
    backLink={`/su/accounts/${account ? account.accountId : ''}/triangulations`}
    headerText={`${account ? account.accountName : ''} ${category} transactions`}
    centered={!account || !transactionList}>
    {
      (!account || !transactionList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && transactionList &&
      <BankAnalyzerSF context={context} account={account} show={true}
        onRefreshClick={onRefreshClick}
      />
    }

    <div className='g_m_top_100'>
      {
        transactionList && transactionList.length === 0 &&
        <>
          <LRTableActionsUI location='top'
            left={
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
            }
            right={
              <span />
            }
          />
          <span>{yearMonth}, across all bank accounts</span>
          <EmptyListUI className='g_m_top_200'
            context={context}
            createDisabledMessageLabel='No transactions'
          />
        </>
      }

      {
        transactionList && transactionList.length !== 0 &&
        <ClientTxnCashTransactionListSF
          context={context}
          account={account}
          category={category}

          yearMonth={yearMonth}
          transactionList={transactionList}
          //
          hasMore={hasMore}
          gettingMore={gettingMore}
          onMoreTransactions={onMoreTransactions}
          //
          onRefreshClick={onRefreshClick}
        />
      }
    </div>
  </SuperUserPageSF>

export default ClientTxnCashTransactionListPageUI
